
/* ============================== src/api/queries/weekly-reminders.js ============================== */
// src/api/queries/weekly-reminders.js
/**
 * Хуки напоминаний о часах. Четыре операции под prefix /api/v1:
 *   GET   /settings/weekly-reminder   → WeeklyReminderSettings
 *   PATCH /settings/weekly-reminder   → WeeklyReminderSettings
 *   POST  /weekly-reminders/preview   → Reminder[]  (без отправки)
 *   POST  /weekly-reminders/send      → { sent: number }
 *
 * useUpdateWeeklyReminderSettingsMutation инвалидирует settings —
 * ["weekly-reminders", "settings"]. После PATCH UI «Последняя
 * автоотправка» и поля формы перечитываются.
 *
 * useSendWeeklyRemindersMutation не инвалидирует settings: на фронте
 * всегда вызывается с force: true (Cabinet.handleWrSendNow), а
 * sendReminders обновляет lastSentAt только при force !== true
 * (WeeklyReminderService.sendReminders). То есть при ручной отправке
 * lastSentAt не меняется — инвалидация была бы no-op.
 *
 * usePreviewWeeklyRemindersMutation read-only: invalidate не нужен.
 * Ответ Reminder[] содержит employee/norm/fact/deviation/overwork/
 * remaining/tasks/periodRange — этого достаточно WeeklyReminderPreviewModal.
 */
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../client";

export const WEEKLY_REMINDERS_KEY = ["weekly-reminders"];

export function useWeeklyReminderSettingsQuery(options = {}) {
  return useQuery({
    queryKey: [...WEEKLY_REMINDERS_KEY, "settings"],
    queryFn: () => api.get("/settings/weekly-reminder"),
    staleTime: 30 * 1000,
    ...options,
  });
}

export function useUpdateWeeklyReminderSettingsMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => api.patch("/settings/weekly-reminder", body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [...WEEKLY_REMINDERS_KEY, "settings"] });
    },
  });
}

export function useSendWeeklyRemindersMutation() {
  return useMutation({
    mutationFn: (body) => api.post("/weekly-reminders/send", body),
  });
}

export function usePreviewWeeklyRemindersMutation() {
  return useMutation({
    mutationFn: (body) => api.post("/weekly-reminders/preview", body),
  });
}
